import { Component, OnInit, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { ReportingService } from '../../../../reporting/reporting.service';
import {
  GridModule,
  PDFModule,
  ExcelModule,
  GridComponent,
} from '@progress/kendo-angular-grid';
import { SimpleLoadingComponent } from '../../../../shared-components/simple-loading/simple-loading.component';
import { SVGIcon, filePdfIcon, fileExcelIcon } from '@progress/kendo-svg-icons';
import { WarnDialogComponent } from '../../../../warn-dialog/warn-dialog.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-bridge-action-detail-modal',
  imports: [
    MatDialogModule,
    GridModule,
    PDFModule,
    ExcelModule,
    MatButtonModule,
    SimpleLoadingComponent,
    MatIconModule,
  ],
  templateUrl: './bridge-action-detail-modal.component.html',
  styleUrl: './bridge-action-detail-modal.component.scss',
})
export class BridgeActionDetailModalComponent implements OnInit {
  data = inject(MAT_DIALOG_DATA);
  dialogRef =
    inject<MatDialogRef<BridgeActionDetailModalComponent>>(MatDialogRef);
  private rptSvc = inject(ReportingService);
  private dialog = inject(MatDialog);

  detailData;
  displayStart;
  displayEnd;
  loading = false;

  public pdfSVG: SVGIcon = filePdfIcon;
  public excelSVG: SVGIcon = fileExcelIcon;

  ngOnInit(): void {
    if (this.data.startDate && this.data.endDate) {
      this.displayStart = new Date(this.data.startDate).toDateString();
      this.displayEnd = new Date(this.data.endDate).toDateString();
    }
    this.loading = true;
    this.rptSvc
      .getBridgeActionDetail(
        this.data.dataItem?.unitID,
        this.data.startDate,
        this.data.endDate
      )
      .subscribe(res => {
        this.detailData = res.results;
        this.loading = false;
      });
  }

  exportToExcel(grid: GridComponent): void {
    let dialogRef = this.dialog.open(WarnDialogComponent, {
      panelClass: 'warn-dialog',
      data: {
        headline: 'Disclosure',
        aiDisclosure: true,
        confirm: 'Agree and Download',
        cancel: 'Cancel/Exit',
        hideCancel: false,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'continue') {
        grid.saveAsExcel();
      }
      dialogRef = null;
    });
  }

  exportToPDF(grid: GridComponent): void {
    let dialogRef = this.dialog.open(WarnDialogComponent, {
      panelClass: 'warn-dialog',
      data: {
        headline: 'Disclosure',
        aiDisclosure: true,
        confirm: 'Agree and Download',
        cancel: 'Cancel/Exit',
        hideCancel: false,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'continue') {
        grid.saveAsPDF();
      }
      dialogRef = null;
    });
  }

  closeModal(ev) {
    this.dialogRef.close();
  }
}
